export const Config = {
  // BASE_URL: 'http://localhost:3000'
  BASE_URL: 'https://api.dustmanrecycling.com'
  // BASE_URL: 'http://apidev.dustmanrecycling.com:3000'
  // BASE_URL: 'https://957f2db35f760d7c181feaa1d39d2992.serveo.net'
};
